import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import AnimationPreferences from "./animation-preferences";

gsap.registerPlugin(ScrollTrigger);

class AnimationScroll {
    constructor(options) {
        if (!AnimationPreferences.shouldAnimate()) return;
        this.defaults = {
            trigger: "[data-gsap-scroll-container]",
            staggerChildren: "[data-gsap-animate]",
            stagger: 0.05,
            easing: "back.out(1.7)",
            duration: 0.8,
            markers: false,
            ...options
        };

        this.init();
    }

    init() {
        const sections = document.querySelectorAll(this.defaults.trigger);
        sections.forEach(section => {
            section.animateChildren = section.querySelectorAll(this.defaults.staggerChildren);
            if (section.animateChildren.length) {
                this.animateSection(section);
            }
        });
    }

    animateSection(section) {
        const effect = section.dataset.gsapEffect || 'fade-up';
        const duration = section.dataset.gsapDuration || this.defaults.duration;
        const stagger = section.dataset.gsapStagger || this.defaults.stagger;
        const delay = section.dataset.gsapDelay || 0;

        let initialValues = { opacity: 0 };

        switch (effect) {
            case 'fade-down':
                initialValues.y = -100;
                break;
            case 'scale-up':
                initialValues.scale = 0.8;
                break;
            case 'scale-down':
                initialValues.scale = 1.2;
                break;
            case 'slide-left':
                initialValues.x = 100;  // Always from right
                break;
            case 'slide-right':
                initialValues.x = -100; // Always from left
                break;
            default: // fade-up
                initialValues.y = 100;
        }

        gsap.fromTo(section.animateChildren, {
            ...initialValues
        }, {
            y: 0,
            x: 0,
            scale: 1,
            opacity: 1,
            stagger: stagger,
            ease: this.defaults.easing,
            duration: duration,
            delay: delay,
            scrollTrigger: {
                trigger: section,
                start: "top 75%",
                end: "bottom 20%",
                once: true,
                markers: this.defaults.markers,
                onLeave: () => {
                    gsap.set(section.animateChildren, {
                        clearProps: "all",
                        attr: {
                            'data-gsap-animate': 'animated'
                        },
                    });
                },
            }
        });
    }
}

export default {
    init() {
        if (!AnimationPreferences.shouldAnimate()) return;

        new AnimationScroll();
    }
}
